import React, { useState } from 'react';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';

export default function ShippingSection({ order, onShipmentCreated }) {
  const { isPrivileged } = useAuth();
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [extraFields, setExtraFields] = useState({ pincode: '', weight: '0.5' });

  const handleCreate = async () => {
    setLoading(true); setError('');
    try {
      const { data } = await api.post(`/orders/${order.id}/shipment`, extraFields);
      onShipmentCreated(data);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to create shipment');
    } finally { setLoading(false); }
  };

  if (order.waybill_number) {
    return (
      <div style={{ marginTop: 12, padding: '10px 14px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8 }}>
        <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#15803d', marginBottom: 4 }}>
          Shipment Booked
        </div>
        <div style={{ fontSize: '0.78rem', color: '#166534' }}>
          Waybill: <strong>{order.waybill_number}</strong>
          {order.shipping_status && (
            <span style={{ marginLeft: 8, background: '#dcfce7', padding: '1px 8px', borderRadius: 10 }}>
              {order.shipping_status}
            </span>
          )}
        </div>
        <a href={order.tracking_url} target="_blank" rel="noopener noreferrer"
          style={{ display: 'inline-block', marginTop: 6, fontSize: '0.78rem', color: '#0891b2', textDecoration: 'none', fontWeight: 600 }}>
          Track on Delhivery &rarr;
        </a>
      </div>
    );
  }

  if (!isPrivileged) return null;

  return (
    <div style={{ marginTop: 12, padding: '10px 14px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 }}>
      <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#475569', marginBottom: 8 }}>Create Shipment (Delhivery)</div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <input className="form-control" placeholder="Pincode" value={extraFields.pincode}
          onChange={e => setExtraFields(p => ({ ...p, pincode: e.target.value }))}
          style={{ flex: 1, fontSize: '0.82rem' }} />
        <input className="form-control" placeholder="Weight (kg)" type="number" step="0.1" value={extraFields.weight}
          onChange={e => setExtraFields(p => ({ ...p, weight: e.target.value }))}
          style={{ width: 110, fontSize: '0.82rem' }} />
      </div>
      {error && <div style={{ fontSize: '0.78rem', color: '#dc2626', marginBottom: 6 }}>{error}</div>}
      <button className="btn btn-sm btn-primary" onClick={handleCreate} disabled={loading || !extraFields.pincode}>
        {loading ? 'Creating…' : 'Book Shipment'}
      </button>
    </div>
  );
}
